/* Google Maps JS API loader + dark luxury map style.
   Replaces the previous Mapbox direction. A real interactive map renders only when
   REACT_APP_GOOGLE_MAPS_API_KEY is present; otherwise portals fall back to the
   styled visual panel (see RouteMap in components/portal/opsui.jsx). */

export const GMAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
export const hasGoogleMaps = () => Boolean(GMAPS_KEY);

let loaderPromise = null;

export function loadGoogleMaps() {
  if (!GMAPS_KEY) return Promise.reject(new Error("google-maps-key-missing"));
  if (typeof window !== "undefined" && window.google && window.google.maps) {
    return Promise.resolve(window.google.maps);
  }
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const cbName = "__nanak_gmaps_ready";
    window[cbName] = () => resolve(window.google.maps);
    const script = document.createElement("script");
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(GMAPS_KEY)}` +
      `&libraries=places&loading=async&callback=${cbName}`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      loaderPromise = null;
      reject(new Error("google-maps-load-failed"));
    };
    document.head.appendChild(script);
  });
  return loaderPromise;
}

/* Dark map theme tuned to the obsidian + bronze portal palette. */
export const DARK_MAP_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#0a0b0e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#0a0b0e" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#8b8f9a" }] },
  { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#2a2d34" }] },
  { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#c9a44c" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#171920" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#101217" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#6b6f79" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#23262e" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#05060a" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3b3f48" }] },
];

/* SVG pin symbol in the portal gold, used for pickup/drop-off markers. */
export const goldPin = (maps, fill = "#E5C158") => ({
  path: "M12 0C7 0 3 4 3 9c0 6.5 9 15 9 15s9-8.5 9-15c0-5-4-9-9-9z",
  fillColor: fill,
  fillOpacity: 1,
  strokeColor: "#0a0b0e",
  strokeWeight: 1.5,
  scale: 1.4,
  anchor: new maps.Point(12, 24),
});
